<script lang="ts">
  import { changeNews } from "../../services"
  import CuratorsFilters from "../../../../custom/Curators/CuratorsFilters.svelte"
</script>

<CuratorsFilters on:change={changeNews} />